import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { GetProductivityParameterGroupsInputDto, ProductivityParameterGroupCreateDto, ProductivityParameterGroupDto, ProductivityParameterGroupExcelDownloadDto, ProductivityParameterGroupUpdateDto } from '../dtos/productivity-parameter-group/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class ProductivityParameterGroupService {
  apiName = 'WoodSupply';
  

  create = (input: ProductivityParameterGroupCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ProductivityParameterGroupDto>({
      method: 'POST',
      url: '/api/woodSupply/productivityParameterGroups',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/woodSupply/productivityParameterGroups/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/woodSupply/productivityParameterGroups',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ProductivityParameterGroupDto>({
      method: 'GET',
      url: `/api/woodSupply/productivityParameterGroups/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/woodSupply/productivityParameterGroups/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetProductivityParameterGroupsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<ProductivityParameterGroupDto>>({
      method: 'GET',
      url: '/api/woodSupply/productivityParameterGroups',
      params: { code: input.code, name: input.name, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: ProductivityParameterGroupExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/woodSupply/productivityParameterGroups/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, code: input.code, name: input.name, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ProductivityParameterGroupDto[]>({
      method: 'GET',
      url: '/api/woodSupply/productivityParameterGroups/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: ProductivityParameterGroupUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ProductivityParameterGroupDto>({
      method: 'PUT',
      url: `/api/woodSupply/productivityParameterGroups/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
